import styled from 'styled-components';

export const TooltipPanel = styled.div`
  .onsite-tooltip-container {
    font-size: 16px;
    margin-top: 8px;
    margin-left: 6px;
  }
`;
